import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { CourseList } from 'src/app/components/course/course-list';
import { ViewMaterial, ViewMaterialDefaultValues } from 'src/app/components/materials/materials';
import { AuthService } from 'src/app/services/auth.service';
import { FileService } from 'src/app/services/file.service';
import { MaterialsService } from 'src/app/services/materials.service';
import { ModalService } from 'src/app/services/modal.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-view-material',
    templateUrl: './view-material.component.html',
    styleUrls: ['./view-material.component.scss'],
    standalone: false
})
export class ViewMaterialComponent {
  viewmaterial: ViewMaterial = ViewMaterialDefaultValues();
  materialid: string = '';
  materialStatus: string = "";
  tagNames: any[] = [];
  modalSub!: Subscription;
  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  showReplacementDiv: boolean = false;
  courseList: CourseList[] = [];
  coursecolumnsToDisplay = [
    'id',
    'name',
    'program',
    'enrollment',
    'status',
  ];
  auditLogs: any[] = [];
  pageName = CheckPageAccess.MATERIALS;
  showeditbutton = this.authservice.getAccessControl().editMaterials;
  information: string = '';

  constructor(private materialservice: MaterialsService,
    private route: ActivatedRoute,
    private router: Router,
    private fileservice: FileService,
    private _modalservice: ModalService,
    private _toastservice: ToastService,
    private authservice: AuthService)
  { }

  async ngOnInit(): Promise<void> {
    this.information = "<h4>Associated Courses</h4>" +
      "Course Assosciation can only be edited within Course Administration";

    await this.route.params.subscribe(params => {
      this.materialid = params['id'];
      this.materialservice.getMaterialDetailsById(this.materialid).subscribe({
        next:(response) => {
          this.viewmaterial=response;
          this.materialStatus = response.status.toString().toLowerCase();
          this.tagNames = response.tags.map((t:any) => t.tagName);
          this.courseList = response.courses;
        }
      })
    });

    await this.materialservice.getMaterialAuditLogs(this.materialid).subscribe({
      next:(logs) => {
        this.auditLogs = logs;
      }
    });

    this.afterConfirmModalOps();
  }

  downloadFile(){
    this.fileservice.downloadMaterialFile(this.viewmaterial.materialFileId).subscribe({
      next:(response) => {
        window.open(response.url, '_blank');
      }
    })
  }

  downloadReplacementFile() {
    this.fileservice.downloadMaterialFile(this.viewmaterial.replacementMaterialFileId).subscribe({
      next:(response) => {
        window.open(response.url, '_blank');
      }
    });
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }

  askConfirmation(
    okButtonText: string,
    okButtonValue: string,
    cancelButtonText: string,
    cancelButtonValue: string,
    content: string,
    title: string) {
      this.modalContent = content;
      this.modalTitle = title;
      this.modalOkButtonValue = okButtonValue;
      this.modalCancelButtonValue = cancelButtonValue;
      this.modalOkButtonText = okButtonText;
      this.modalCancelButtonText = cancelButtonText;

      this._modalservice.openModal();
  }

  afterConfirmModalOps() {
    this.modalSub = this._modalservice
      .getButtonClicked()
      .subscribe((button) => {
        switch (button) {
          case 'YES':
            this.materialservice.deleteMaterial(this.materialid).subscribe({
              next: (response: any) => {
                this._toastservice.showMessage("Material Deleted Successfully");
                this.router.navigate(['/material-list']);
              }
            })
          break;
          default:
            this._modalservice.closeModal();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalSub) {
      this.modalSub.unsubscribe();
    }
  }

  deleteMaterial() {
    this.askConfirmation("Yes,Delete",
      'YES',
      'No,Cancel',
      'NO',
      'Are you sure you want to delete this material?',
      'Delete Material');
  }
}
